import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToastService } from '@shared/services/toaster/toaster.service';

@Component({
  selector: 'app-toaster',
  imports: [CommonModule],
  templateUrl: './toaster.html',
  styleUrl: './toaster.scss'
})
export class Toaster {
  constructor(public toastService : ToastService){}
}
